import React, {Component} from "react";
import {connect} from "react-redux";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import InlineTable from "../../components/InlineTable";
import {graphql} from "react-apollo";
import {GET_ACCOUNT_WITH_BILLING, ON_BILLING_UPDATED, ON_UPDATED_CART} from "../../queries/customers";

const FIELDS = fromJS([
  { field: "productSku", title: "Account Purchases" },
  { field: "quantity", title: "Qty"}
])

class AccountPropertiesPanel extends Component {

  componentDidMount() {
    if (this.props.accountId && this.props.accountId !== "") {
      this.subscribe(this.props.accountId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.accountId && (prevProps.accountId !== this.props.accountId)) {
      this.subscribe(this.props.accountId);
    }
  }

  subscribe(accountId) {
    if (this.unsubscribeToBillingUpdates) {
      this.unsubscribeToBillingUpdates();
    }
    if (this.unsubscribeToCartUpdates) {
      this.unsubscribeToCartUpdates();
    }
    this.unsubscribeToBillingUpdates = this.props.subscribeToBillingUpdates(this.props, {});
    this.unsubscribeToCartUpdates = this.props.subscribeToCartUpdates(this.props, {});
  }

  render() {
    let elements = null;
    let purchasesTable = null;
    if (!this.props.accountId) {
      elements = <p className="u-no-selection">Nothing selected</p>
    } else {
      let {loading, error, account, billingAccount, salesAccountPurchases, cart} = this.props.data;
      if (loading) return <Loading />
      if (error) return <GraphQLErrors error={error} />

      let properties = fromJS([
        {prop: "account.name", label: "Name", type: "string"},
        {prop: "account.accountId", label: "Id", type: "accountId"},
        {prop: "account.vip", label: "VIP Account", type: "boolean"},

        {prop: "billingAccount.type", label: "Type", type: "string"},
        {prop: "billingAccount.shopId", label: "Shop", type: "id"},
        {prop: "billingAccount.currency", label: "Currency", type: "id"},
        {prop: "billingAccount.paymentMethod", label: "Payment Meth.", type: "paymentMethod"},
        {prop: "billingAccount.paymentTermsDays", label: "Payment Terms", type: "id", suffix: "days"},
        {prop: "billingAccount.stripeId", label: "Stripe Id", type: "id"},
        {prop: "billingAccount.status", label: "Status", type: "string"},
        {prop: "billingAccount.taxId", label: "Tax Id", type: "string"},
        {prop: "billingAccount.validTaxId", label: "EU Tax ID", type: "boolean"},
        {prop: "billingAccount.taxExempt", label: "Tax Exempt", type: "boolean"},
        {prop: "billingAccount.taxExemptionDescription", label: "Tax Ex. Desc.", type: "string"},

        {prop: "---pricing", label: "Pricing", type: "category"},
        {prop: "cart.subscriberPricelist", label: "Subscriber/VIP", type: "boolean"},
        {prop: "cart.subscriptionPricelistVersion", label: "Sub. Pricelist", type: "string"},
        {prop: "cart.productPricelistVersion", label: "Product Pricelist", type: "string"},

        {prop: "---billing", label: "Billing Address", type: "category"},
        {prop: "billingAccount.address.name", label: "Name", type: "string"},
        {prop: "billingAccount.address", label: "Address", type: "address"},
        
        {prop: "---subscriptions", label: "Subscriptions", type: "category"},
        {prop: "account.subsActive", label: "Active", type: "integer"},
        {prop: "account.subsPaused", label: "Paused", type: "integer"},
        {prop: "account.subsCancelled", label: "Cancelled", type: "integer"},
        
        {prop: "---policies", label: "Cart Policies", type: "category"},
        {prop: "cart.subscriptionsPolicy", label: "Subscriptions", type: "string", help: "Wether subscriptions can be added to cart"},
        {prop: "cart.waterOrdersPolicy", label: "Water Ad-hoc", type: "string", help: "Wether bottles of water can be ordered (not subscription)"},
        {prop: "cart.productOrdersPolicy", label: "Products", type: "string", help: "Wether other products such as dispensers can be ordered"},
      ])
      let data = {account, billingAccount, cart, salesAccountPurchases}
      elements = <PropertiesList properties={properties} data={fromJS(data)} />

      purchasesTable = <InlineTable
        data={fromJS(data.salesAccountPurchases).get("products")}
        fields={FIELDS}
        dataType="account_purchases"
        />              
    }

    return (
      <PanelGroupController title="Account" expanded={this.props.expanded}>
        {elements}
        <br/>
        {purchasesTable}
      </PanelGroupController>
    )
  }

}


const mapDispatchToProps = dispatch => ({
  subscribeToBillingUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_BILLING_UPDATED,
      variables: {
        accountId: props.accountId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  },
  subscribeToCartUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_CART,
      variables: {
        accountId: props.accountId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }  
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(GET_ACCOUNT_WITH_BILLING, {
  skip: (props) => !props.accountId,
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      accountId: props.accountId
    }
  })
})

export default withQuery(withSubscription(AccountPropertiesPanel));
